export default __webpack_public_path__ + "static/media/calibracements-zementauswahl.50a70fc5.png";